import { Analytics } from './analytics';
import { ItemRefineSearchAction } from '../item_refine_search/item_refine_search_action';
import { AdobeAnalyticsMOrSCategoryPagingData } from '../../models/analytics/async_m_and_s_category_paging_data';

/// Adobe Analytics 非同期中小カテゴリー検索ページング用送信クラス
export class AsyncSearchMAndSCategoryPagingAnalytics extends Analytics {
  constructor() {
    super();
    ItemRefineSearchAction.SEND_M_AND_S_CATEGORY_PAGING_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: data.friendlyPageName,
          events: this.events(data),
          categoryLL: window.analyticsData.categoryLL,
          categoryL: window.analyticsData.categoryL,
          categoryM: window.analyticsData.categoryM,
          categoryS: window.analyticsData.categoryS,
          searchKeyword: '',
          listDisplayType: window.analyticsData.listDisplayType,
          paging: window.analyticsData.paging,
          variationCode: window.analyticsData.variationCode,
          sortType: window.analyticsData.sortType,
          searchCondition: window.analyticsData.searchCondition,
          searchSpecCondition: window.analyticsData.searchSpecCondition,
          club: {
            server: 'club/pc',
            prop5: data.friendlyPageName,
            events: this.events(data),
            prop12: window.analyticsData.club.prop12,
            prop13: window.analyticsData.club.prop13,
            prop14: window.analyticsData.club.prop14,
            prop15: window.analyticsData.club.prop15,
            prop16: '',
            prop18: window.analyticsData.club.prop18,
            prop19: window.analyticsData.club.prop19,
            prop51: window.analyticsData.club.prop51,
            prop52: window.analyticsData.club.prop52,
            prop57: window.analyticsData.club.prop57
          },
          soloel: {
            server: 'soloel/pc',
            prop5: data.friendlyPageName,
            events: ['event2'],
            prop12: window.analyticsData.soloel.prop12,
            prop13: window.analyticsData.soloel.prop13,
            prop14: window.analyticsData.soloel.prop14,
            prop15: window.analyticsData.soloel.prop15,
            prop19: window.analyticsData.soloel.prop19,
            prop51: window.analyticsData.soloel.prop51,
            prop52: window.analyticsData.soloel.prop52,
            prop57: window.analyticsData.soloel.prop57,
            eVar78: window.analyticsData.soloel.eVar78
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }

  private events(data: AdobeAnalyticsMOrSCategoryPagingData) {
    const events = ['event2', 'event14'];

    if (data.analyticsData.bundleDiscountCpnFlg === '1') {
      events.push('event223');
    }

    return events;
  }
}
